import { isM } from "./alpha"

// ---------------------------------------------------------------------------

const w = window.innerWidth
const h = window.innerHeight

export let values = {
    camera: {
        fov: 75,
        pos: {x: 0, y: 12, z: -20},
        target: {x: 0, y: 9, z: 0}
    }
}

if(isM) {
    // values.camera.pos.z = 40
}